import { useDocument } from "./useDocument"

export const useRoadmap = () => {
    const { document: roadmapDoc } = useDocument('public','roadmap')
    return {roadmapDoc}
}